import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { CATEGORY_LABELS } from "../lib/api";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  return (
    <div
      className="bg-white rounded-lg border border-[#262626]/10 p-4 transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] flex flex-col"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/products/${product.id}`} className="block">
        <div className="bg-[#F9F6F0] rounded-md overflow-hidden aspect-square mb-4 relative">
          <img src={product.image} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
          <span className="absolute top-2 left-2 bg-[#262626] text-[#F9F6F0] text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded">
            {CATEGORY_LABELS[product.category]}
          </span>
        </div>
      </Link>
      <Link to={`/products/${product.id}`} className="font-display font-bold text-base text-[#262626] leading-snug hover:text-[#D32F2F] transition-colors line-clamp-2 min-h-[3rem]">
        {product.name}
      </Link>
      <div className="mt-3 flex items-center justify-between">
        <span className="font-display font-black text-xl text-[#262626]" data-testid={`product-price-${product.id}`}>
          ${product.price.toFixed(2)}
        </span>
        <button
          onClick={() => addItem(product)}
          data-testid={`add-to-cart-${product.id}`}
          className="bg-[#D32F2F] text-white text-sm font-bold px-4 py-2 rounded-md hover:bg-[#B71C1C] transition-colors"
        >
          Add to Cart
        </button>
      </div>
    </div>
  );
};
